import { useNavigate } from "react-router-dom";
import { ArticleForm } from "@/components/articles/article-form";
import { useCreateArticle } from "@/hooks/use-articles";
import type { BlogArticleFormValues } from "@/lib/validation/article-schema";

export default function ArticleNewPage() {
  const navigate = useNavigate();
  const { mutate: createArticle, isPending } = useCreateArticle();

  const handleSubmit = (data: BlogArticleFormValues) => {
    createArticle(data);
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          새 블로그 아티클
        </h1>
        <p className="text-muted-foreground leading-normal">
          새로운 블로그 아티클을 작성합니다.
        </p>
      </div>

      <div className="max-w-2xl">
        <ArticleForm
          onSubmit={handleSubmit}
          onCancel={() => navigate("/articles")}
          isSubmitting={isPending}
          submitLabel="아티클 생성"
        />
      </div>
    </div>
  );
}
